import React from 'react';
import {StyleSheet, View, Text} from 'react-native';
import {OfferListItem} from 'src/components';
import {IService} from 'src/domains';
import LocalText from 'src/local';

export type RelatedOffersListProps = {
  offers: IService[];
  onOffer: (offer: IService) => void;
};

export const RelatedOffersList: React.FC<RelatedOffersListProps> = ({
  offers,
  onOffer,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.header}>
        <Text style={styles.title}>
          {LocalText.components.relatedOffersList.header}
        </Text>
      </View>
      {offers.map(item => (
        <OfferListItem
          key={item.id}
          offer={item}
          onPress={() => onOffer(item)}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    marginTop: 8,
    paddingVertical: 8,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingHorizontal: 16,
    marginBottom: 16,
  },
  title: {
    flex: 1,
    fontSize: 16,
    fontWeight: 'bold',
  },
});
